import { combineReducers } from "redux";
import auth from "./authReducer";
import blog from "./blogReducer";
import post from "./postReducer";
import tag from "./tagReducer";
import book from "./bookReducer";
import com from "./comReducer";
import search from "./searchReducer";
import notification from "./notificationReducer";
import modalReducer from "./modalReducer";

const rootReducer = combineReducers({
  auth,
  blog,
  post,
  tag,
  book,
  com,
  search,
  notification,
  modalReducer
});

export default rootReducer;
